import { defineStore } from 'pinia';
import actions from './actions'

function initState() {
    return {
        seoData: [],
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    actions
});
